(() => {
  const decodeHtml = (value) => {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = value;
    return textarea.value;
  };

  const formatCounterValue = (value, decimals, prefix, suffix) => {
    const fixed = Number(value).toFixed(decimals);
    return `${prefix}${fixed}${suffix}`;
  };

  const animateCounter = (element) => {
    const endValue = Number(element.dataset.endValue || 0);
    const decimals = Number(element.dataset.decimals || 0);
    const prefix = decodeHtml(element.dataset.prefix || "");
    const suffix = element.dataset.suffix || "";
    const duration = 1800;
    const startTime = performance.now();

    const step = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = 1 - Math.pow(1 - progress, 3);
      const currentValue = endValue * easedProgress;

      element.textContent = formatCounterValue(currentValue, decimals, prefix, suffix);

      if (progress < 1) {
        window.requestAnimationFrame(step);
        return;
      }

      element.textContent = formatCounterValue(endValue, decimals, prefix, suffix);
    };

    window.requestAnimationFrame(step);
  };

  const initLoyaltyCounters = () => {
    const counterElements = document.querySelectorAll("[data-loyalty-counter]");

    if (!counterElements.length) return;

    counterElements.forEach((element) => {
      const prefix = decodeHtml(element.dataset.prefix || "");
      const suffix = element.dataset.suffix || "";
      element.textContent = formatCounterValue(0, 0, prefix, suffix);
    });

    const counterObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          animateCounter(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.45 }
    );

    counterElements.forEach((element) => {
      counterObserver.observe(element);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initLoyaltyCounters, { once: true });
    return;
  }

  initLoyaltyCounters();
})();
